/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit MedicalHistory/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import Content from './Content/index'
import EnsureUrl from 'DesignSystem/EnsureUrl/react'
import Location from './Location/index'
import React from 'react'
import SubMenuTab from 'DesignSystem/SubMenuTab/index'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function MedicalHistory({
  children,
  viewPath = "/App/Account/Content/Settings/Content/MedicalHistory"
  
}) {
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let dtSpaceL = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.l'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
  return (<React.Fragment
>
<EnsureUrl
  viewPath={`${viewPath}/EnsureUrl`}
/>
<div
  data-testid="MedicalHistory.Vertical"
  data-view-path={viewPath}
 style={{'--pt-1-WDa0c': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="MedicalHistory.Vertical:1"
  data-view-path={viewPath}
 style={{'--pl-2-WDa0c': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL,'--pr-3-WDa0c': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL}}
 className={`views-block ${styles.Vertical1}`}
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h2"
 text="Medical history"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="medium"
 marginTop={dtSpaceXs}
 color={dtColorsNeutral500}
 text="Manage the medical history questions for each location. Add, edit, or remove the medical history questions."
/>
<Location
  viewPath={`${viewPath}/Location`}
/>
</div>
<div
  data-testid="MedicalHistory.Vertical:2"
  data-view-path={viewPath}
 style={{'--mt-4-WDa0c': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Vertical2}`}
>
<div
  data-testid="MedicalHistory.Horizontal"
  data-view-path={viewPath}
 style={{'--pl-2-WDa0c': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL,'--pr-3-WDa0c': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL}}
 className={`views-block ${styles.Horizontal}`}
>
<SubMenuTab
  viewPath={`${viewPath}/SubMenuTab`}
 size="medium"
 text="Questions"
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, 'Content/Questions'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, 'Content/Questions'))}
/>
<SubMenuTab
  viewPath={`${viewPath}/SubMenuTab`}
 size="medium"
 text="Settings"
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, 'Content/Settings'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, 'Content/Settings'))}
/>
</div>
<div
  data-testid="MedicalHistory.Vertical:3"
  data-view-path={viewPath}
 style={{'--pl-2-WDa0c': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL,'--pr-3-WDa0c': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL}}
 className={`views-block ${styles.Vertical3}`}
>
<Content
  viewPath={`${viewPath}/Content`}
/>
</div>
</div>
</div>
{children}
</React.Fragment>)
}